import { type EnvType } from '../../infra/environment'
import { type featureFlag } from './constants.featureFlags'
import { featureFlagManager } from './featureFlagManager'

const DEFAULT_OPTIONS = {
  flagManager: featureFlagManager,
}

function getEnv(env?: EnvType) {
  return env ? { currentEnv: env } : env
}

/**
 * @deprecated Use https://github.com/loadsmart/carrier-web/wiki/Remote-Configs instead
 */
export function useFeatureFlag(
  flag: featureFlag,
  config?: { flagManager?: typeof featureFlagManager; currentEnv?: EnvType }
) {
  const { flagManager, currentEnv } = { ...DEFAULT_OPTIONS, ...config }
  const managerConfig = getEnv(currentEnv)

  return {
    isEnabled: flagManager.isEnabledForEnv(flag, managerConfig),
  }
}

export type UseFeatureFlagParams = Parameters<typeof useFeatureFlag>
